'usr strict';

import controller from './resumen.controller';
import template from './resumen.html';

const ResumenComputosComponent = {
  bindings: {
    item: '<',
    resumen: '<'
  },
  controller,
  template
};

export default ResumenComputosComponent;



// WEBPACK FOOTER //
// ./src/app/components/reg-empresas/computo-proyecto/resumen/resumen.component.js